<app-rail-loading-screen [animated]="false"></app-rail-loading-screen>
<app-express-loading-screen [animated]="false"></app-express-loading-screen>
@if (originalResultsNotFound$ | async) {
  <div class="light-error-box">
    <p i18n="@@rail_original_results_expired">
      This rail search result is no longer available. Please start a new search.
    </p>
    <a
      class="light-btn light-btn-primary"
      routerLink="/search"
      i18n="@@rail_original_results_start_new_search"
      >Start a new rail search</a
    >
  </div>
} @else {
  @if (searchParams?.ukRail && !searchService.search_loading) {
    <app-rail></app-rail>
  }
  @if (searchParams && !searchParams.ukRail && !searchService.search_loading) {
    <app-trainline-eu-results></app-trainline-eu-results>
  }
}
